import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

export default function FAQ() {
  return (
    <section id="faq" className="py-12 lg:py-28 bg-wash">
      <div className="section-pad max-w-[1000px] mx-auto">
        <div className="text-center mb-8 sm:mb-14">
          <span className="eyebrow justify-center"><span className="dot" /> Frequently Asked</span>
          <h2 className="font-display mt-4 sm:mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.08] tracking-tight">
            The right protection, <br className="hidden md:block" /> <span className="font-serif italic font-normal text-accent-orange">selected around your vehicle.</span>
          </h2>
          <p className="mt-3 sm:mt-4 text-[#5a5548] max-w-lg mx-auto text-sm sm:text-base">Answers to common questions about PPF, coatings, wrapping and everyday use.</p>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="card-elevated rounded-2xl px-4 sm:px-6 border-0">
              <AccordionTrigger className="text-left text-[0.95rem] sm:text-[1rem] font-semibold text-[#16150f] hover:text-[#ff5a1f] hover:no-underline py-4 sm:py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[0.92rem] text-[#5a5548] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
